import { makeModuleStateSelector } from "@client/content/selectors";
import { defaultState } from "./reducer";
import { type ForgotPassword } from "./types";

export const localStateSelector = makeModuleStateSelector<ForgotPassword.AppState>(defaultState, defaultState);
